<template>
  <div id="quiz">
    <header>
      <a href="/">
        <img class="logo logo-desktop" src="./../assets/img/logos/logo-driessen-desktop.svg" alt="Driessen Logo">
        <img class="logo logo-mobile" src="./../assets/img/logos/logo-driessen-mobile.svg" alt="Driessen Logo">
      </a>
    </header>
    <main>
      <form>
        <h1>Test je werkgeluk</h1>
        <div v-if="step === 1">
          <div class="user">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 1 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">ALGEMEEN</span>
                </div>
                <div class="question" v-bind:class="{ 'fade-out': nextStepActive }">In welke provincie woon je?</div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path" v-bind:class="{ 'user-path-animation': progressActive }" fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer align-left">
                <div class="label">Kies je provincie</div>
                <input type="radio" id="p-1" value="drenthe" name="drenthe" v-model="province"/>
                <label for="p-1">Drenthe</label>
                <input type="radio" id="p-2" value="gelderland" name="gelderland" v-model="province"/>
                <label for="p-2">Gelderland</label>
                <input type="radio" id="p-3" value="groningen" name="groningen" v-model="province"/>
                <label for="p-3">Groningen</label>
                <input type="radio" id="p-4" value="flevoland" name="flevoland" v-model="province"/>
                <label for="p-4">Flevoland</label>
                <input type="radio" id="p-5" value="friesland" name="friesland" v-model="province"/>
                <label for="p-5">Friesland</label>
                <input type="radio" id="p-6" value="limburg" name="limburg" v-model="province"/>
                <label for="p-6">Limburg</label>
                <input type="radio" id="p-7" value="noord_brabant" name="noord_brabant" v-model="province"/>
                <label for="p-7">Noord-Brabant</label>
                <input type="radio" id="p-8" value="noord_holland" name="noord_holland" v-model="province"/>
                <label for="p-8">Noord-Holland</label>
                <input type="radio" id="p-9" value="overijssel" name="overijssel" v-model="province"/>
                <label for="p-9">Overijssel</label>
                <input type="radio" id="p-10" value="utrecht" name="utrecht" v-model="province"/>
                <label for="p-10">Utrecht</label>
                <input type="radio" id="p-11" value="zeeland" name="zeeland" v-model="province"/>
                <label for="p-11">Zeeland</label>
                <input type="radio" id="p-12" value="zuid_holland" name="zuid_holland" v-model="province"/>
                <label for="p-12">Zuid-Holland</label>
              </div>
            </div>
            <button class="next-step" id="question-01" v-on:click.prevent="nextStep(false)" v-if="province && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 2">
          <div class="user">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 1 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">ALGEMEEN</span>
                </div>
                <div class="question" v-bind:class="{ 'fade-out': nextStepActive }">Hoe oud ben je?
                </div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'user-path-animation-2': progressActive, 'user-path-animation-set': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'user-path-animation': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer align-left">
                <div class="label">Kies je leeftijdscategorie</div>
                <input type="radio" id="ag-1" value="<_18" name="<_18" v-model="age_category"/>
                <label for="ag-1">< 18 jaar</label>
                <input type="radio" id="ag-2" value="18_25" name="18_25" v-model="age_category"/>
                <label for="ag-2">18 – 25 jaar</label>
                <input type="radio" id="ag-3" value="26_30" name="26_30" v-model="age_category"/>
                <label for="ag-3">26 – 30 jaar</label>
                <input type="radio" id="ag-4" value="31_35" name="31_35" v-model="age_category"/>
                <label for="ag-4">31 – 35 jaar</label>
                <input type="radio" id="ag-5" value="36_40" name="36_40" v-model="age_category"/>
                <label for="ag-5">36 – 40 jaar</label>
                <input type="radio" id="ag-6" value="41_45" name="41_45" v-model="age_category"/>
                <label for="ag-6">41 – 45 jaar</label>
                <input type="radio" id="ag-7" value="46_50" name="46_50" v-model="age_category"/>
                <label for="ag-7">46 – 50 jaar</label>
                <input type="radio" id="ag-8" value="51_55" name="51_55" v-model="age_category"/>
                <label for="ag-8">51 – 55 jaar</label>
                <input type="radio" id="ag-9" value="56_60" name="56_60" v-model="age_category"/>
                <label for="ag-9">56 – 60 jaar</label>
                <input type="radio" id="ag-10" value="60_70" name="60_70" v-model="age_category"/>
                <label for="ag-10">60 – 67 jaar</label>
                <input type="radio" id="ag-11" value=">_67" name=">_67" v-model="age_category"/>
                <label for="ag-11">> 67 jaar</label>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step" id="question-02" v-on:click.prevent="nextStep(false)"
                    v-if="age_category && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 3">
          <div class="user">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 1 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">ALGEMEEN</span>
                </div>
                <div class="question" v-bind:class="{ 'fade-out': nextStepActive }">Wat is je geslacht?</div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'user-path-animation-3': progressActive, 'user-path-animation-set-2': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'user-path-animation-2': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer align-left">
                <div class="label">Kies je geslacht</div>
                <input type="radio" id="g-1" value="male" name="male" v-model="gender"/>
                <label for="g-1">Man</label>
                <input type="radio" id="g-2" value="female" name="female" v-model="gender"/>
                <label for="g-2">Vrouw</label>
                <input type="radio" id="g-3" value="anders" name="anders" v-model="gender"/>
                <label for="g-3">Anders</label>
                <input type="radio" id="g-4" value="zegiklieverniet" name="zegiklieverniet" v-model="gender"/>
                <label for="g-4">Zeg ik liever niet</label>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step" id="question-03" v-on:click.prevent="nextStep(false)" v-if="!gender && !nextStepActive">
              Overslaan
            </button>
            <button class="next-step" id="question-03" v-on:click.prevent="nextStep(false)" v-if="gender && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 4">
          <div class="user">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 1 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">ALGEMEEN</span>
                </div>
                <div class="question" v-bind:class="{ 'fade-out': nextStepActive }">Wat is je opleidingsniveau?
                </div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'user-path-animation-4': progressActive, 'user-path-animation-set-3': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'user-path-animation-3': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer align-left">
                <div class="label">Kies je opleidingsniveau</div>
                <input type="radio" id="he-1" value="basis" name="basis" v-model="highest_education"/>
                <label for="he-1">Basis</label>
                <input type="radio" id="he-2" value="vmbo" name="vmbo" v-model="highest_education"/>
                <label for="he-2">VMBO</label>
                <input type="radio" id="he-3" value="havo" name="havo" v-model="highest_education"/>
                <label for="he-3">HAVO</label>
                <input type="radio" id="he-4" value="vwo" name="vwo" v-model="highest_education"/>
                <label for="he-4">VWO</label>
                <input type="radio" id="he-5" value="mbo" name="mbo" v-model="highest_education"/>
                <label for="he-5">MBO</label>
                <input type="radio" id="he-6" value="hbo" name="hbo" v-model="highest_education"/>
                <label for="he-6">HBO</label>
                <input type="radio" id="he-7" value="wo" name="wo" v-model="highest_education"/>
                <label for="he-7">WO</label>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step" id="question-04" v-on:click.prevent="nextStep(false)"
                    v-if="highest_education && !nextStepActive">Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 5 && !unemployed">
          <div class="user">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 1 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">ALGEMEEN</span>
                </div>
                <div class="question" v-bind:class="{ 'fade-out': nextStepActive }">Heb je op dit moment een baan?</div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'user-path-animation-5': progressActive, 'user-path-animation-set-4': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'user-path-animation-4': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer align-left">
                <div class="label">Heb je op dit moment een baan?</div>
                <input type="radio" id="j-1" value="yes" name="yes" v-model="job"/>
                <label for="j-1">Ja</label>
                <input type="radio" id="j-2" value="no" name="no" v-model="job"/>
                <label for="j-2">Nee</label>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step" id="question-05" v-on:click.prevent="nextStep(false)"
                    v-if="job === 'yes' && !nextStepActive">
              Volgende
            </button>
            <button class="next-step" id="question-05" v-on:click.prevent="noJob" v-if="job === 'no' && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 6">
          <div class="user">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 1 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">ALGEMEEN</span>
                </div>
                <div class="question" v-bind:class="{ 'fade-out': nextStepActive }">Wat is je functieniveau?</div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'user-path-animation-6': progressActive, 'user-path-animation-set-5': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'user-path-animation-5': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer align-left">
                <div class="label">Wat is je functieniveau?</div>
                <input type="radio" id="f-1" value="zzp_zmp" name="zzp_zmp" v-model="functional_level"/>
                <label for="f-1">ZZP/ZMP</label>
                <input type="radio" id="f-2" value="director" name="director" v-model="functional_level"/>
                <label for="f-2">Directeur</label>
                <input type="radio" id="f-3" value="manager" name="manager" v-model="functional_level"/>
                <label for="f-3">Manager</label>
                <input type="radio" id="f-4" value="teamleader_coordinator" name="teamleader_coordinator"
                       v-model="functional_level"/>
                <label for="f-4">Teamleider/coördinator</label>
                <input type="radio" id="f-5" value="advisor" name="advisor" v-model="functional_level"/>
                <label for="f-5">Adviseur</label>
                <input type="radio" id="f-6" value="researcher" name="researcher"
                       v-model="functional_level"/>
                <label for="f-6">Onderzoeker</label>
                <input type="radio" id="f-7" value="support_operational" name="support_operational"
                       v-model="functional_level"/>
                <label for="f-7">Ondersteunend/uitvoerend</label>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step" id="question-06" v-on:click.prevent="nextStep(false)"
                    v-if="functional_level && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 7">
          <div class="user">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 1 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">ALGEMEEN</span>
                </div>
                <div class="question" v-bind:class="{ 'fade-out': nextStepActive }">In welke sector ben je werkzaam?
                </div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'user-path-animation-7': progressActive, 'user-path-animation-set-6': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'user-path-animation-6': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer align-left">
                <div class="label">Kies je sector</div>
                <input type="radio" id="s-1" value="trade_transport_hospitality" name="trade_transport_hospitality"
                       v-model="sector"/>
                <label for="s-1">Handel, vervoer en horeca</label>
                <input type="radio" id="s-2" value="business_services" name="business_services" v-model="sector"/>
                <label for="s-2">Zakelijke dienstverlening</label>
                <input type="radio" id="s-3" value="healthcare" name="healthcare" v-model="sector"/>
                <label for="s-3">Zorg en welzijn</label>
                <input type="radio" id="s-4" value="culture_recreation_other" name="culture_recreation_other"
                       v-model="sector"/>
                <label for="s-4">Cultuur, recreatie, overige diensten</label>
                <input type="radio" id="s-5" value="industry" name="industry" v-model="sector"/>
                <label for="s-5">Industrie</label>
                <input type="radio" id="s-6" value="public_service_government" name="public_service_government"
                       v-model="sector"/>
                <label for="s-6">Openbaar bestuur/overheid</label>
                <input type="radio" id="s-7" value="education" name="education" v-model="sector"/>
                <label for="s-7">Onderwijs</label>
                <input type="radio" id="s-8" value="rental_trade_property" name="rental_trade_property"
                       v-model="sector"/>
                <label for="s-8">Verhuur en handel van onroerend goed</label>
                <input type="radio" id="s-9" value="information_communication" name="information_communication"
                       v-model="sector"/>
                <label for="s-9">Informatie en communicatie</label>
                <input type="radio" id="s-10" value="construction" name="construction" v-model="sector"/>
                <label for="s-10">Bouwnijverheid</label>
                <input type="radio" id="s-11" value="financial_services" name="financial_services" v-model="sector"/>
                <label for="s-11">Financiële dienstverlening</label>
                <input type="radio" id="s-12" value="agriculture_fishery" name="agriculture_fishery" v-model="sector"/>
                <label for="s-12">Landbouw en visserij</label>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step" id="question-07" v-on:click.prevent="nextStep(false)" v-if="sector && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 8">
          <div class="user">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 1 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">ALGEMEEN</span>
                </div>
                <div class="question" v-bind:class="{ 'fade-out': nextStepActive }">Wanneer je nadenkt over je eigen
                  leven,
                  hoe gelukkig ben je?
                </div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'user-path-animation-8': progressActive, 'user-path-animation-set-7': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'user-path-animation-7': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Geef een cijfer</div>
                <div class="radio-elements">
                  <div class="row">
                    <input type="radio" id="h-1" value="1" name="one" v-model="happiness"/>
                    <label for="h-1">1</label>
                    <input type="radio" id="h-2" value="2" name="two" v-model="happiness"/>
                    <label for="h-2">2</label>
                    <input type="radio" id="h-3" value="3" name="three" v-model="happiness"/>
                    <label for="h-3">3</label>
                    <input type="radio" id="h-4" value="4" name="four" v-model="happiness"/>
                    <label for="h-4">4</label>
                    <input type="radio" id="h-5" value="5" name="five" v-model="happiness"/>
                    <label for="h-5">5</label>
                  </div>
                  <div class="row">
                    <input type="radio" id="h-6" value="6" name="six" v-model="happiness"/>
                    <label for="h-6">6</label>
                    <input type="radio" id="h-7" value="7" name="seven" v-model="happiness"/>
                    <label for="h-7">7</label>
                    <input type="radio" id="h-8" value="8" name="eight" v-model="happiness"/>
                    <label for="h-8">8</label>
                    <input type="radio" id="h-9" value="9" name="nine" v-model="happiness"/>
                    <label for="h-9">9</label>
                    <input type="radio" id="h-10" value="10" name="ten" v-model="happiness"/>
                    <label for="h-10">10</label>
                  </div>
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step" id="question-08" v-on:click.prevent="nextStep(false)" v-if="happiness && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 9">
          <div class="user">
            <div class="left" v-bind:class="{ 'fade-out': leftFadeOut, 'fade-in': leftFadeIn }">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 1 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">ALGEMEEN</span>
                </div>
                <div class="question" v-bind:class="{ 'fade-out': nextStepActive }">Wanneer je nadenkt over je eigen
                  baan,
                  hoe gelukkig ben je met je werk/ in je
                  werksituatie?
                </div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'user-path-animation-9': progressActive, 'user-path-animation-set-8': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'user-path-animation-8': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Geef een cijfer</div>
                <div class="radio-elements">
                  <div class="row">
                    <input type="radio" id="hj-1" value="1" name="one" v-model="happiness_job"/>
                    <label for="hj-1">1</label>
                    <input type="radio" id="hj-2" value="2" name="two" v-model="happiness_job"/>
                    <label for="hj-2">2</label>
                    <input type="radio" id="hj-3" value="3" name="three" v-model="happiness_job"/>
                    <label for="hj-3">3</label>
                    <input type="radio" id="hj-4" value="4" name="four" v-model="happiness_job"/>
                    <label for="hj-4">4</label>
                    <input type="radio" id="hj-5" value="5" name="five" v-model="happiness_job"/>
                    <label for="hj-5">5</label>
                  </div>
                  <div class="row">
                    <input type="radio" id="hj-6" value="6" name="six" v-model="happiness_job"/>
                    <label for="hj-6">6</label>
                    <input type="radio" id="hj-7" value="7" name="seven" v-model="happiness_job"/>
                    <label for="hj-7">7</label>
                    <input type="radio" id="hj-8" value="8" name="eight" v-model="happiness_job"/>
                    <label for="hj-8">8</label>
                    <input type="radio" id="hj-9" value="9" name="nine" v-model="happiness_job"/>
                    <label for="hj-9">9</label>
                    <input type="radio" id="hj-10" value="10" name="ten" v-model="happiness_job"/>
                    <label for="hj-10">10</label>
                  </div>
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step" id="question-09" v-on:click.prevent="nextStep(true)"
                    v-if="happiness_job && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 10">
          <div class="solidarity">
            <div class="left" v-bind:class="{ 'fade-out': rightFadeOut, 'fade-in': rightFadeIn }">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 2 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">VERBONDENHEID</span>
                </div>
                <div class="question fade-in" v-bind:class="{ 'fade-out': nextStepActive }">Op het werk voel ik me
                  onderdeel
                  van een groep
                </div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation': progressActive }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="part-5" value="4" name="totallyAgree" v-model="part" class="totally-agree"/>
                  <label for="part-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="part-4" value="3" name="agree" v-model="part" class="agree"/>
                  <label for="part-4" v-on:mouseover="mouseOver('agree', 'Mee eens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="part-3" value="2" name="neutral" v-model="part" class="neutral"/>
                  <label for="part-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="part-2" value="1" name="disagree" v-model="part" class="disagree"/>
                  <label for="part-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="part-1" value="0" name="totallyDisagree" v-model="part"
                         class="totally-disagree"/>
                  <label for="part-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && part">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(true)">Vorige</button>
            <button class="next-step btn-bes" id="question-10" v-on:click.prevent="nextStep(false)"
                    v-if="part && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 11">
          <div class="solidarity">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 2 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">VERBONDENHEID</span>
                </div>
                <div class="question">Op het werk kan ik met mensen praten over dingen die echt belangrijk voor me zijn
                </div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation-2': progressActive, 'path-animation-set': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'path-animation': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="important-5" value="4" name="totallyAgree" v-model="important"
                         class="totally-agree"/>
                  <label for="important-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="important-4" value="3" name="agree" v-model="important" class="agree"/>
                  <label for="important-4" v-on:mouseover="mouseOver('agree', 'Mee eens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="important-3" value="2" name="neutral" v-model="important" class="neutral"/>
                  <label for="important-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="important-2" value="1" name="disagree" v-model="important" class="disagree"/>
                  <label for="important-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="important-1" value="0" name="totallyDisagree" v-model="important"
                         class="totally-disagree"/>
                  <label for="important-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && important">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step btn-bes" id="question-11" v-on:click.prevent="nextStep(false)"
                    v-if="important && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 12">
          <div class="solidarity">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 2 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">VERBONDENHEID</span>
                </div>
                <div class="question">Sommige mensen met wie ik werk, zijn goede vrienden van me</div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation-3': progressActive, 'path-animation-set-2': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'path-animation-2': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="friends-5" value="4" name="totallyAgree" v-model="friends"
                         class="totally-agree"/>
                  <label for="friends-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="friends-4" value="3" name="agree" v-model="friends" class="agree"/>
                  <label for="friends-4" v-on:mouseover="mouseOver('agree', 'Mee eens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="friends-3" value="2" name="neutral" v-model="friends" class="neutral"/>
                  <label for="friends-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="friends-2" value="1" name="disagree" v-model="friends" class="disagree"/>
                  <label for="friends-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="friends-1" value="0" name="totallyDisagree" v-model="friends"
                         class="totally-disagree"/>
                  <label for="friends-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && friends">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step btn-bes" id="question-12" v-on:click.prevent="nextStep(false)"
                    v-if="friends && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 13">
          <div class="solidarity">
            <div class="left" v-bind:class="{ 'fade-out': leftFadeOut, 'fade-in': leftFadeIn }">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 2 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">VERBONDENHEID</span>
                </div>
                <div class="question" v-bind:class="{ 'fade-out': nextStepActive }">Op het werk zijn er mensen die me
                  echt
                  begrijpen
                </div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation-4': progressActive, 'path-animation-set-3': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'path-animation-3': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="understand-5" value="4" name="totallyAgree" v-model="understand"
                         class="totally-agree"/>
                  <label for="understand-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="understand-4" value="3" name="agree" v-model="understand" class="agree"/>
                  <label for="understand-4" v-on:mouseover="mouseOver('agree', 'Mee eens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="understand-3" value="2" name="neutral" v-model="understand" class="neutral"/>
                  <label for="understand-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="understand-2" value="1" name="disagree" v-model="understand"
                         class="disagree"/>
                  <label for="understand-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="understand-1" value="0" name="totallyDisagree" v-model="understand"
                         class="totally-disagree"/>
                  <label for="understand-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && understand">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step btn-bes" id="question-13" v-on:click.prevent="nextStep(true)"
                    v-if="understand && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 14">
          <div class="competence">
            <div class="left" v-bind:class="{ 'fade-out': rightFadeOut, 'fade-in': rightFadeIn }">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 3 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">COMPETENTIE</span>
                </div>
                <div class="question fade-in">Ik beheers de taken op mijn werk</div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation': progressActive }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="control-5" value="4" name="totallyAgree" v-model="control"
                         class="totally-agree"/>
                  <label for="control-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="control-4" value="3" name="agree" v-model="control" class="agree"/>
                  <label for="control-4" v-on:mouseover="mouseOver('agree', 'Mee eens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="control-3" value="2" name="neutral" v-model="control" class="neutral"/>
                  <label for="control-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="control-2" value="1" name="disagree" v-model="control" class="disagree"/>
                  <label for="control-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="control-1" value="0" name="totallyDisagree" v-model="control"
                         class="totally-disagree"/>
                  <label for="control-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && control">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(true)">Vorige</button>
            <button class="next-step btn-bes" id="question-14" v-on:click.prevent="nextStep(false)"
                    v-if="control && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 15">
          <div class="competence">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 3 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">COMPETENTIE</span>
                </div>
                <div class="question">Ik kan mijn werk goed uitvoeren</div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation-2': progressActive, 'path-animation-set': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'path-animation': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="performance-5" value="4" name="totallyAgree" v-model="performance"
                         class="totally-agree"/>
                  <label for="performance-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="performance-4" value="3" name="agree" v-model="performance" class="agree"/>
                  <label for="performance-4" v-on:mouseover="mouseOver('agree', 'Mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="performance-3" value="2" name="neutral" v-model="performance"
                         class="neutral"/>
                  <label for="performance-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="performance-2" value="1" name="disagree" v-model="performance"
                         class="disagree"/>
                  <label for="performance-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="performance-1" value="0" name="totallyDisagree" v-model="performance"
                         class="totally-disagree"/>
                  <label for="performance-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && performance">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step btn-bes" id="question-15" v-on:click.prevent="nextStep(false)"
                    v-if="performance && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 16">
          <div class="competence">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 3 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">COMPETENTIE</span>
                </div>
                <div class="question">Ik ben goed in de dingen die ik in mijn werk doe</div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation-3': progressActive, 'path-animation-set-2': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'path-animation-2': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="doing-well-5" value="4" name="totallyAgree" v-model="doing_well"
                         class="totally-agree"/>
                  <label for="doing-well-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="doing-well-4" value="3" name="agree" v-model="doing_well" class="agree"/>
                  <label for="doing-well-4" v-on:mouseover="mouseOver('agree', 'Mee eens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="doing-well-3" value="2" name="neutral" v-model="doing_well" class="neutral"/>
                  <label for="doing-well-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="doing-well-2" value="1" name="disagree" v-model="doing_well"
                         class="disagree"/>
                  <label for="doing-well-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="doing-well-1" value="0" name="totallyDisagree" v-model="doing_well"
                         class="totally-disagree"/>
                  <label for="doing-well-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && doing_well">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step btn-bes" id="question-16" v-on:click.prevent="nextStep(false)"
                    v-if="doing_well && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 17">
          <div class="competence">
            <div class="left" v-bind:class="{ 'fade-out': leftFadeOut, 'fade-in': leftFadeIn }">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 3 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">COMPETENTIE</span>
                </div>
                <div class="question" v-bind:class="{ 'fade-out': nextStepActive }">Ik heb het gevoel dat ik zelfs de
                  moeilijkste taken op mijn werk kan volbrengen
                </div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation-4': progressActive, 'path-animation-set-3': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'path-animation-3': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="hardest-tasks-5" value="4" name="totallyAgree" v-model="hardest_tasks"
                         class="totally-agree"/>
                  <label for="hardest-tasks-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="hardest-tasks-4" value="3" name="agree" v-model="hardest_tasks"
                         class="agree"/>
                  <label for="hardest-tasks-4" v-on:mouseover="mouseOver('agree', 'Mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="hardest-tasks-3" value="2" name="neutral" v-model="hardest_tasks"
                         class="neutral"/>
                  <label for="hardest-tasks-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="hardest-tasks-2" value="1" name="disagree" v-model="hardest_tasks"
                         class="disagree"/>
                  <label for="hardest-tasks-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="hardest-tasks-1" value="0" name="totallyDisagree" v-model="hardest_tasks"
                         class="totally-disagree"/>
                  <label for="hardest-tasks-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && hardest_tasks">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step btn-bes" id="question-17" v-on:click.prevent="nextStep(true)"
                    v-if="hardest_tasks && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 18">
          <div class="autonomy">
            <div class="left" v-bind:class="{ 'fade-out': rightFadeOut, 'fade-in': rightFadeIn }">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 4 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">AUTONOMIE</span>
                </div>
                <div class="question fade-in">Ik voel me vrij om mijn ideeën en meningen in mijn werk uit te drukken
                </div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation': progressActive }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="expression-5" value="4" name="totallyAgree" v-model="expression"
                         class="totally-agree"/>
                  <label for="expression-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="expression-4" value="3" name="agree" v-model="expression" class="agree"/>
                  <label for="expression-4" v-on:mouseover="mouseOver('agree', 'Mee eens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="expression-3" value="2" name="neutral" v-model="expression" class="neutral"/>
                  <label for="expression-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="expression-2" value="1" name="disagree" v-model="expression"
                         class="disagree"/>
                  <label for="expression-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="expression-1" value="0" name="totallyDisagree" v-model="expression"
                         class="totally-disagree"/>
                  <label for="expression-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && expression">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step btn-bes" id="question-19" v-on:click.prevent="nextStep(false)"
                    v-if="expression && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 19">
          <div class="autonomy">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 4 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">AUTONOMIE</span>
                </div>
                <div class="question">Ik heb het gevoel dat ik mezelf kan zijn in mijn werk</div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation-2': progressActive, 'path-animation-set': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'path-animation': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="myself-5" value="4" name="totallyAgree" v-model="myself"
                         class="totally-agree"/>
                  <label for="myself-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="myself-4" value="3" name="agree" v-model="myself" class="agree"/>
                  <label for="myself-4" v-on:mouseover="mouseOver('agree', 'Mee eens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="myself-3" value="2" name="neutral" v-model="myself" class="neutral"/>
                  <label for="myself-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="myself-2" value="1" name="disagree" v-model="myself" class="disagree"/>
                  <label for="myself-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="myself-1" value="0" name="totallyDisagree" v-model="myself"
                         class="totally-disagree"/>
                  <label for="myself-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && myself">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step btn-bes" id="question-19" v-on:click.prevent="nextStep(false)"
                    v-if="myself && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 20">
          <div class="autonomy">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 4 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">AUTONOMIE</span>
                </div>
                <div class="question">De taken die ik op mijn werk moet doen, liggen in de lijn van wat ik echt wil doen
                </div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation-3': progressActive, 'path-animation-set-2': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'path-animation-2': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="want-5" value="4" name="totallyAgree" v-model="want" class="totally-agree"/>
                  <label for="want-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="want-4" value="3" name="agree" v-model="want" class="agree"/>
                  <label for="want-4" v-on:mouseover="mouseOver('agree', 'Mee eens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="want-3" value="2" name="neutral" v-model="want" class="neutral"/>
                  <label for="want-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="want-2" value="1" name="disagree" v-model="want" class="disagree"/>
                  <label for="want-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="want-1" value="0" name="totallyDisagree" v-model="want"
                         class="totally-disagree"/>
                  <label for="want-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && want">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step btn-bes" id="question-20" v-on:click.prevent="nextStep(false)"
                    v-if="want && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 21">
          <div class="autonomy">
            <div class="left" v-bind:class="{ 'fade-out': leftFadeOut, 'fade-in': leftFadeIn }">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 4 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">AUTONOMIE</span>
                </div>
                <div class="question" v-bind:class="{ 'fade-out': nextStepActive }">Ik voel me vrij om mijn werk te doen
                  zoals
                  ik denk dat dit het beste kan worden
                  gedaan
                </div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation-4': progressActive, 'path-animation-set-3': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'path-animation-3': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="best-5" value="4" name="totallyAgree" v-model="best" class="totally-agree"/>
                  <label for="best-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="best-4" value="3" name="agree" v-model="best" class="agree"/>
                  <label for="best-4" v-on:mouseover="mouseOver('agree', 'Mee eens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="best-3" value="2" name="neutral" v-model="best" class="neutral"/>
                  <label for="best-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="best-2" value="1" name="disagree" v-model="best" class="disagree"/>
                  <label for="best-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="best-1" value="0" name="totallyDisagree" v-model="best"
                         class="totally-disagree"/>
                  <label for="best-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && best">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step btn-bes" id="question-21" v-on:click.prevent="nextStep(true)"
                    v-if="best && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 22">
          <div class="social">
            <div class="left" v-bind:class="{ 'fade-out': rightFadeOut, 'fade-in': rightFadeIn }">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 5 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">MAATSCHAPPELIJKE RELEVANTIE</span>
                </div>
                <div class="question fade-in">In mijn werk kan ik iets betekenen voor anderen</div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation': progressActive }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="meaning-5" value="4" name="totallyAgree" v-model="meaning"
                         class="totally-agree"/>
                  <label for="meaning-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="meaning-4" value="3" name="agree" v-model="meaning" class="agree"/>
                  <label for="meaning-4" v-on:mouseover="mouseOver('agree', 'Mee eens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="meaning-3" value="2" name="neutral" v-model="meaning" class="neutral"/>
                  <label for="meaning-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="meaning-2" value="1" name="disagree" v-model="meaning" class="disagree"/>
                  <label for="meaning-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="meaning-1" value="0" name="totallyDisagree" v-model="meaning"
                         class="totally-disagree"/>
                  <label for="meaning-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && meaning">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(true)">Vorige</button>
            <button class="next-step btn-bes" id="question-22" v-on:click.prevent="nextStep(false)"
                    v-if="meaning && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 23">
          <div class="social">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 5 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">MAATSCHAPPELIJKE RELEVANTIE</span>
                </div>
                <div class="question">Ik heb het gevoel dat mijn werk ertoe doet</div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation-2': progressActive, 'path-animation-set': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'path-animation': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="matters-5" value="4" name="totallyAgree" v-model="matters"
                         class="totally-agree"/>
                  <label for="matters-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="matters-4" value="3" name="agree" v-model="matters" class="agree"/>
                  <label for="matters-4" v-on:mouseover="mouseOver('agree', 'Mee eens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="matters-3" value="2" name="neutral" v-model="matters" class="neutral"/>
                  <label for="matters-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="matters-2" value="1" name="disagree" v-model="matters" class="disagree"/>
                  <label for="matters-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="matters-1" value="0" name="totallyDisagree" v-model="matters"
                         class="totally-disagree"/>
                  <label for="matters-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && matters">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step btn-bes" id="question-23" v-on:click.prevent="nextStep(false)"
                    v-if="matters && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 24">
          <div class="social">
            <div class="left">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 5 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">MAATSCHAPPELIJKE RELEVANTIE</span>
                </div>
                <div class="question">Ik zie duidelijk hoe mijn eigen werk bijdraagt aan de organisatie</div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation-3': progressActive, 'path-animation-set-2': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'path-animation-2': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="contribute-5" value="4" name="totallyAgree" v-model="contribute"
                         class="totally-agree"/>
                  <label for="contribute-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="contribute-4" value="3" name="agree" v-model="contribute" class="agree"/>
                  <label for="contribute-4" v-on:mouseover="mouseOver('agree', 'Mee eens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="contribute-3" value="2" name="neutral" v-model="contribute" class="neutral"/>
                  <label for="contribute-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="contribute-2" value="1" name="disagree" v-model="contribute"
                         class="disagree"/>
                  <label for="contribute-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="contribute-1" value="0" name="totallyDisagree" v-model="contribute"
                         class="totally-disagree"/>
                  <label for="contribute-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && contribute">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step btn-bes" id="question-24" v-on:click.prevent="nextStep(false)"
                    v-if="contribute && !nextStepActive">
              Volgende
            </button>
          </div>
        </div>
        <div v-if="step === 25">
          <div class="social">
            <div class="left" v-bind:class="{ 'fade-out': nextStepActive }">
              <div class="left-contents">
                <div class="progress-indicator fade-in">
                  <span class="progress-indicator__theme">THEMA</span>
                  <span class="progress-indicator__current"> 5 </span>
                  <span class="progress-indicator__total">/ 5</span>
                  <span class="progress-indicator__chapter">MAATSCHAPPELIJKE RELEVANTIE</span>
                </div>
                <div class="question" v-bind:class="{ 'fade-out': nextStepActive }">Ik zie duidelijk hoe mijn werk
                  bijdraagt
                  aan de maatschappij
                </div>
              </div>
            </div>
            <div class="right">
              <div class="progress-bar">
                <div class="base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1280"
                       height="432" viewBox="0 0 1280 432">
                    <path class="path"
                          v-bind:class="{ 'path-animation-4': progressActive, 'path-animation-set-3': !progressActive, 'user-path-animation-reverse': progressBackReverse, 'path-animation-3': progressBackAnimation }"
                          fill="none"
                          stroke="#F4F0EC" stroke-width="15"
                          d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                          transform="rotate(14 1890.92 -1077.114)"></path>
                  </svg>
                  <div class="backline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="432" viewBox="0 0 1280 432">
                      <path fill="none" stroke="#e71234" stroke-width="13"
                            d="M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796"
                            transform="rotate(14 1890.92 -1077.114)"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="answer">
                <div class="label">Maak een keuze</div>
                <div class="radio-elements emoticons">
                  <input type="radio" id="society-5" value="4" name="totallyAgree" v-model="society"
                         class="totally-agree"/>
                  <label for="society-5" v-on:mouseover="mouseOver('totallyAgree', 'Helemaal mee eens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyAgree', 'Helemaal mee eens')"><span>Helemaal mee eens</span></label>
                  <input type="radio" id="society-4" value="3" name="agree" v-model="society" class="agree"/>
                  <label for="society-4" v-on:mouseover="mouseOver('agree', 'Mee eens')" v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('agree', 'Mee eens')"><span>Mee eens</span></label>
                  <input type="radio" id="society-3" value="2" name="neutral" v-model="society" class="neutral"/>
                  <label for="society-3" v-on:mouseover="mouseOver('neutral', 'Niet mee eens, niet mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('neutral', 'Niet mee eens, niet mee oneens')"><span>Niet mee eens, niet mee oneens</span></label>
                  <input type="radio" id="society-2" value="1" name="disagree" v-model="society" class="disagree"/>
                  <label for="society-2" v-on:mouseover="mouseOver('disagree', 'Mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('disagree', 'Mee oneens')"><span>Mee oneens</span></label>
                  <input type="radio" id="society-1" value="0" name="totallyDisagree" v-model="society"
                         class="totally-disagree"/>
                  <label for="society-1" v-on:mouseover="mouseOver('totallyDisagree', 'Helemaal mee oneens')"
                         v-on:mouseleave="mouseLeave"
                         v-on:click="mouseClick('totallyDisagree', 'Helemaal mee oneens')"><span>Helemaal mee oneens</span></label>
                </div>
                <div class="label" v-if="hoverActive">
                  {{ opinions.totallyAgree }}
                  {{ opinions.agree }}
                  {{ opinions.neutral }}
                  {{ opinions.disagree }}
                  {{ opinions.totallyDisagree }}
                </div>
                <div class="label" v-else-if="!hideChecked && society">
                  {{ checked.totallyAgree }}
                  {{ checked.agree }}
                  {{ checked.neutral }}
                  {{ checked.disagree }}
                  {{ checked.totallyDisagree }}
                </div>
              </div>
            </div>
            <button class="previous-step btn-bes btn-prev" v-on:click.prevent="previousStep(false)">Vorige</button>
            <button class="next-step btn-gras" id="question-25" type="submit" v-on:click.prevent="finishUp"
                    v-if="society && !nextStepActive" :disabled="submitting" :aria-busy="submitting">
              <span class="button-spinner" v-if="submitting" aria-hidden="true"></span>
              <span v-if="submitting">Verzenden...</span>
              <span v-else>Verzenden</span>
            </button>
            <div class="label" v-if="submitError">
              Je inzending kon niet worden opgeslagen. Probeer het opnieuw.
              <a href="#" v-on:click.prevent="finishUp">Opnieuw proberen</a>
            </div>
          </div>
        </div>
        <div v-if="step === 26">
          <div class="user user-results">
            <div class="left results" v-bind:class="classResults">
              <div class="left-contents">
                <div class="label-white-large fade-in" v-if="success === false">Volgens deze test is jouw werkgelukcijfer een</div>
                <div class="label-white-large fade-in" v-if="success === true">De tips zijn naar je verzonden</div>
                <div class="response heartBeat animated" v-if="success === false">
                  <div class="emoticon" v-bind:class="emotionsResults"></div>
                  {{ grade }}
                </div>
                <div class="speech-bubble explanation flipInX animated" v-if="success === false">
                  <h3>Deze score is gebaseerd op 4 factoren:</h3>
                  <ul class="checklist checklist--green">
                    <li>je relatie met collega's</li>
                    <li>je competenties</li>
                    <li>je vrijheid in je werk</li>
                    <li>je manier van mensen gelukkig maken</li>
                  </ul>
                </div>
                <a class="button" href="#subscribe" v-if="success === false">ik wil graag tips ontvangen</a>
                <div class="response tips-sent" v-if="success === true">e</div>
              </div>
            </div>
            <div class="right">
              <div class="tips" v-if="success === false">
                <h2>Jouw werkgeluk vergroten?</h2>
                <p class="explanation">Deze score is gebaseerd op 4 factoren die invloed hebben op je werkgeluk; de
                  relatie met je
                  collega’s,
                  hoe goed jij je competenties kan benutten in je functie, de vrijheid die je hebt en de
                  maatschappelijke
                  relevantie die je werk heeft.</p>
                <a id="subscribe"></a>
                <p>Benieuwd hoe jij je werkgeluk kunt vergroten? Of wil je meer inzicht in jouw werkgelukcijfer? Waar scoor je hoog op en waar juist lager? Op basis van jouw score geven we je inzicht in de verschillende factoren én geven we je tips hoe jij je werkgeluk kunt vergroten. Laat hieronder je gegevens achter en je ontvangt de toelichting met tips in je e-mail.</p>
                <div>
                  <label for="name">Wat is je naam?</label>
                  <input id="name" type="text" name="name" size="60" maxlength="60" placeholder="Je naam" v-model="name">
                </div>
                <div>
                  <label for="email">Wat is je e-mailadres?</label>
                  <input id="email" type="email" name="email" size="60" maxlength="254" placeholder="Je e-mailadres" v-model="email"
                         v-bind:class="{ error: invalidEmail }" v-on:input="invalidEmail = false">
                  <div class="label" role="alert" v-if="invalidEmail">Vul een geldig e-mailadres in.</div>
                </div>
                <div>
                  <input type="checkbox" id="newsletter" v-model="newsletter" value="true" required>
                  <label for="newsletter">Ik ga akkoord met de
                    <router-link :to="{ name: 'GeneralConditions'}" target="_blank">voorwaarden</router-link>.
                    Naast de tips (eenmalig) ontvang ik ook de Werkgeluk kwartaalnieuwsbrief. Hiervoor kan ik mij op ieder gewenst moment eenvoudig afmelden.</label>
                </div>
                <button class="next-step btn-gras" id="form-tips-sent" type="submit" v-on:click.prevent="completeSubmission"
                        v-if="name && email && newsletter" :disabled="completing" :aria-busy="completing">
                  <span class="button-spinner" v-if="completing" aria-hidden="true"></span>
                  <span v-if="completing">Tips versturen...</span>
                  <span v-else>Verzenden</span>
                </button>
                <div class="label" role="alert" v-if="completionError">
                  Je gegevens konden niet worden opgeslagen. Probeer het opnieuw.
                  <a href="#" v-on:click.prevent="completeSubmission">Opnieuw proberen</a>
                </div>
              </div>
              <div class="tips" v-if="success === true">
                <h2>Vind je werkgeluk bij Driessen</h2>
                <p>Bij Driessen vind je werk in de publieke sector. Bij ons kun je terecht voor functies in de overheid,
                  het onderwijs, zorg & welzijn en de cultuursector. Met je talent kun jij anderen helpen, iets leren
                  of zorg je voor anderen. Werk dat de maatschappij mooier en gelukkiger maakt.</p>
                <p>Veel werkgeluk toegewenst!</p>
                <div>
                  <a class="button button--margin" href="https://www.driessen.nl/vacatures?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">bekijk onze vacatures</a>
                </div>
                <div class="button-container">
                  of &nbsp;&nbsp;<a class="button" href="https://www.driessen.nl/content/werkgeluktest-mijn-driessen?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">schrijf je gratis in</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="unemployed">
          <div class="user">
            <div class="left results">
              <div class="left-contents">
                <div class="label-white-large fade-in">Helaas kunnen wij jouw werkgeluk niet meten.</div>
              </div>
            </div>
            <div class="right">
              <div class="tips">
                <h2>Op zoek naar werk waar jij je talent in kwijt kunt?</h2>
                <p>Bij Driessen vind je werk in de publieke sector. Bij ons kun je terecht voor functies in de overheid,
                  het onderwijs, zorg & welzijn en de cultuursector. Met je talent kun jij anderen helpen, iets leren
                  of zorg je voor anderen. Werk dat de maatschappij mooier én gelukkiger maakt. Benieuwd naar de
                  vacatures? Bekijk <a
                    href="https://www.driessen.nl/vacatures?utm_source=test%20je%20werkgeluk&utm_medium=website"
                    target="_blank"
                    rel="noopener noreferrer">hier</a> alle vacatures en solliciteer direct.</p>
                <p>Veel succes toegewenst!</p>
                <a href="https://www.driessen.nl/content/werkgeluktest-mijn-driessen?utm_source=test%20je%20werkgeluk&utm_medium=website"
                   class="button" target="_blank"
                   rel="noopener noreferrer">Schrijf je in</a>
              </div>
            </div>
          </div>
        </div>
      </form>
    </main>
  </div>
</template>
<script>
  import { functions, authReady } from './firebaseInit'
  import { timeCallable } from './callableTiming'

  const createSubmission = functions.httpsCallable('createSubmission');
  const completeSubmission = functions.httpsCallable('completeSubmission');
  const getMailStatus = functions.httpsCallable('getMailStatus');

  export default {
    name: 'Quiz',
    data() {
      return {
        step: 1,
        paramStep: null,
        province: null,
        age_category: null,
        gender: null,
        highest_education: null,
        job: null,
        unemployed: false,
        functional_level: null,
        sector: null,
        happiness: null,
        happiness_job: null,
        answers: [],
        part: null,
        important: null,
        friends: null,
        understand: null,
        control: null,
        performance: null,
        doing_well: null,
        hardest_tasks: null,
        expression: null,
        myself: null,
        want: null,
        best: null,
        meaning: null,
        matters: null,
        contribute: null,
        society: null,
        uid: null,
        resultLink: null,
        submitting: false,
        submitError: false,
        completing: false,
        completionError: false,
        invalidEmail: false,
        grade: null,
        name: null,
        email: null,
        email_return: null,
        newsletter: false,
        success: false,
        mailStatus: 'pending',
        mailStatusError: false,
        mailStatusTimer: null,
        opinions: [],
        checked: [],
        hideChecked: false,
        hoverActive: false,
        progressActive: false,
        nextStepActive: false,
        progressBackReverse: false,
        progressBackAnimation: false,
        leftFadeOut: false,
        leftFadeIn: false,
        rightFadeOut: false,
        rightFadeIn: false,
      }
    },
    computed: {
      classResults: function () {
        return {
          'results-color--red': this.grade < 6,
          'results-color--orange': this.grade >= 6 && this.grade < 7,
          'results-color--green': this.grade >= 7
        }
      },
      emotionsResults: function () {
        return {
          'emoticon--totally-agree': this.grade > 8,
          'emoticon--agree': this.grade >= 6 && this.grade <= 8,
          'emoticon--neutral': this.grade >= 5 && this.grade < 6,
          'emoticon--disagree': this.grade >= 3 && this.grade < 5,
          'emoticon--totally-disagree': this.grade >= 1 && this.grade < 3,
        }
      }
    },
    methods: {
      debug: function () {
        if (window.location.hostname != 'www.testjewerkgeluk.nl') {
          if (this.$route.query.fill) {
            this.province = 'noord_brabant';
            this.age_category = '31_35';
            this.gender = 'female';
            this.highest_education = 'basis';
            this.job = 'yes';
            this.functional_level = 'zzp_zmp';
            this.sector = 'culture_recreation_other';
            this.happiness = this.generateRandomInteger(1, 10).toString();
            this.happiness_job = this.generateRandomInteger(1, 10).toString();
            this.part = this.generateRandomInteger(0, 4).toString();
            this.important = this.generateRandomInteger(0, 4).toString();
            this.friends = this.generateRandomInteger(0, 4).toString();
            this.understand = this.generateRandomInteger(0, 4).toString();
            this.control = this.generateRandomInteger(0, 4).toString();
            this.performance = this.generateRandomInteger(0, 4).toString();
            this.doing_well = this.generateRandomInteger(0, 4).toString();
            this.hardest_tasks = this.generateRandomInteger(0, 4).toString();
            this.expression = this.generateRandomInteger(0, 4).toString();
            this.myself = this.generateRandomInteger(0, 4).toString();
            this.want = this.generateRandomInteger(0, 4).toString();
            this.best = this.generateRandomInteger(0, 4).toString();
            this.meaning = this.generateRandomInteger(0, 4).toString();
            this.matters = this.generateRandomInteger(0, 4).toString();32
            this.contribute = this.generateRandomInteger(0, 4).toString();
            this.society = this.generateRandomInteger(0, 4).toString();
          }
          if (this.$route.query.step) {
            this.step = this.$route.query.step - 1;
            this.nextStep();
          }
          if (this.$route.query.grade) {
            this.grade = this.$route.query.grade;
          }
        }
      },
      generateRandomInteger: function (min, max) {
        return Math.floor(min + Math.random() * (max + 1 - min))
      },
      nextStep: function (switchScreen) {
        this.switchScreenReset();

        this.progressActive = true;
        this.nextStepActive = true;
        this.progressBackReverse = false;
        this.progressBackAnimation = false;
        setTimeout(() => this.step++, 750);
        this.opinions = [];

        // Reset values.
        setTimeout(() => this.progressActive = false, 750);
        setTimeout(() => this.nextStepActive = false, 750);

        // Animation.
        if (switchScreen) {
          this.leftFadeOut = true;
          this.leftFadeIn = false;
          this.rightFadeIn = true;
          this.rightFadeOut = false;
        }
      },
      previousStep: function (switchScreen) {
        this.switchScreenReset();

        this.progressActive = false;
        this.nextStepActive = true;
        this.progressBackReverse = true;
        setTimeout(() => this.progressBackAnimation = true, 100);
        setTimeout(() => this.step--, 750);
        this.opinions = [];

        // Reset values.
        setTimeout(() => this.progressActive = false, 750);
        setTimeout(() => this.nextStepActive = false, 750);
        setTimeout(() => this.progressBackReverse = false, 750);
        setTimeout(() => this.progressBackAnimation = false, 750);

        // Animation.
        if (switchScreen) {
          this.leftFadeOut = false;
          this.leftFadeIn = true;
          this.rightFadeIn = false;
          this.rightFadeOut = true;
        }
      },
      switchScreenReset: function () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
        this.leftFadeOut = false;
        this.leftFadeIn = false;
        this.rightFadeIn = false;
        this.rightFadeOut = false;
      },
      noJob: function () {
        this.unemployed = true;
      },
      mouseOver: function (key, opinion) {
        this.hoverActive = true;
        this.hideChecked = true;
        this.opinions = [];
        this.$set(this.opinions, key, opinion);
      },
      mouseLeave: function () {
        this.hoverActive = false;
        this.hideChecked = false;
        this.opinions = [];
      },
      mouseClick: function (key, checked) {
        this.checked = [];
        this.$set(this.checked, key, checked);
      },
      calculateGrade: function (answers) {
        const answerValues = Object.keys(answers).map((key) => Number(answers[key]));
        const sum = answerValues.reduce((total, answer) => total + answer, 0);
        return sum <= 16 ? 1 : Math.round(sum * 0.15625 * 10) / 10;
      },
      finishUp: function () {
        if (this.submitting) {
          return;
        }
        this.submitting = true;
        this.submitError = false;

        const answers = {
          part: Number(this.part),
          important: Number(this.important),
          friends: Number(this.friends),
          understand: Number(this.understand),
          control: Number(this.control),
          performance: Number(this.performance),
          doing_well: Number(this.doing_well),
          hardest_tasks: Number(this.hardest_tasks),
          expression: Number(this.expression),
          myself: Number(this.myself),
          want: Number(this.want),
          best: Number(this.best),
          meaning: Number(this.meaning),
          matters: Number(this.matters),
          contribute: Number(this.contribute),
          society: Number(this.society)
        };
        const grade = this.calculateGrade(answers);

        timeCallable('createSubmission', authReady, () => {
          return createSubmission({
            data: {
            province: this.province,
            age_category: this.age_category,
            gender: this.gender,
            highest_education: this.highest_education,
            job: this.job,
            functional_level: this.functional_level,
            sector: this.sector,
            happiness: this.happiness,
            happiness_job: this.happiness_job,
            email_return: this.email_return,
            },
            answers: answers,
            grade: grade,
          });
        }).then((response) => {
          // Only navigate to the results step once the submission is
          // confirmed stored; a failed request must never be shown as a
          // successful completion.
          this.uid = response.data.id;
          this.grade = response.data.result.grade;
          this.submitting = false;
          this.nextStep();
        }).catch((error) => {
          console.error('Inzending kon niet worden opgeslagen:', error.code);
          this.submitting = false;
          this.submitError = true;
        });
      },
      completeSubmission: function () {
        if (this.completing || !this.uid) {
          return;
        }
        if (!this.validEmail(this.email)) {
          this.invalidEmail = true;
          return;
        }

        this.completing = true;
        this.completionError = false;
        timeCallable('completeSubmission', authReady, () => {
          return completeSubmission({
            id: this.uid,
            name: this.name,
            email: this.email,
            newsletter: this.newsletter,
          });
        }).then((response) => {
          if (response.data.closed !== true) {
            throw new Error('De inzending is niet afgerond.');
          }
          this.completing = false;
          this.success = true;
          this.mailStatus = 'pending';
          this.mailStatusError = false;
          this.refreshMailStatus();
        }).catch((error) => {
          console.error('Inzending kon niet worden afgerond:', error.code);
          this.completing = false;
          this.completionError = true;
        });
      },
      validEmail: function (email) {
        return typeof email === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
      },
      refreshMailStatus: function () {
        if (!this.uid) {
          return;
        }
        this.mailStatusError = false;
        authReady().then(() => getMailStatus({ id: this.uid }))
          .then((response) => {
            this.mailStatus = response.data.mailStatus;
            if (this.mailStatus === 'pending' || this.mailStatus === 'sending') {
              this.mailStatusTimer = setTimeout(() => this.refreshMailStatus(), 1000);
            }
          })
          .catch(() => {
            // App Check and transport errors intentionally have the same
            // neutral, retryable presentation. There is no weaker fallback
            // for reading the mail status.
            this.mailStatusError = true;
          });
      },
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;

        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
      alertOnLeave: function () {
        window.onbeforeunload = function (e) {
          e.preventDefault();
          return 'Weet je zeker dat je de test af wilt sluiten?';
        };
      },
    },
    mounted() {
      if (this.$route.query.email !== undefined) {
        this.email_return = this.$route.query.email;
      }
      this.debug();
      let querySet = false;
      if (this.$route.query.fill !== undefined || this.$route.query.step !== undefined || this.$route.query.grade !== undefined) {
        querySet = true;
      }
      if (querySet === false) {
        this.alertOnLeave();
      }
      this.toggleBodyClass('addClass', 'quiz');
    },
    destroyed() {
      this.toggleBodyClass('removeClass', 'quiz');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Quiz.vue